import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API } from 'aws-amplify';
import { getVehicle } from '../graphql/queries'; 
// Mantenemos el import por si lo necesitas luego, aunque no lo usaremos en la función
import { createLead } from '../graphql/mutations'; 
import { FaWhatsapp, FaCalendarAlt } from 'react-icons/fa';
import awsmobile from '../aws-exports'; 

const WHATSAPP_NUMBER = "13054076280";

// --- 🟢 FUNCIÓN AUXILIAR DE IMAGEN CORREGIDA (IGUAL A HOME.JS) ---
const getS3ImageUrl = (imageKey) => {
    if (!imageKey) return '/placeholder.jpg'; 
    
    // Usamos el nombre del bucket que ya probamos y funciona
    const BUCKET_NAME = "amplify-vimcarbrokerwebnew-prodstable-cdd61-deployment"; 
    const REGION = "us-east-1"; 
    
    return `https://${BUCKET_NAME}.s3.${REGION}.amazonaws.com/public/${imageKey}`;
};
const DetailPage = () => {
    const { id } = useParams();
    const [vehicle, setVehicle] = useState(null);
    const [mainImage, setMainImage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // ESTADOS PARA EL MODAL DE CITA - Añadimos fecha y hora manteniendo los originales
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [leadForm, setLeadForm] = useState({
        customerName: '',
        customerPhone: '', // Se mantiene en el estado por consistencia con tu objeto original
        appointmentDate: '',
        appointmentTime: '',
    });

    useEffect(() => {
        const fetchVehicle = async () => {
            try {
                const result = await API.graphql({
                    query: getVehicle,
                    variables: { id },
                    authMode: 'API_KEY' 
                });
                const fetchedVehicle = result.data.getVehicle;

                if (fetchedVehicle) {
                    setVehicle(fetchedVehicle);
                    const firstImageKey = fetchedVehicle.imageKey || (fetchedVehicle.allImageKeys && fetchedVehicle.allImageKeys[0]);
                    if (firstImageKey) {
                        setMainImage(getS3ImageUrl(firstImageKey));
                    }
                } else {
                    setError("Vehículo no encontrado.");
                }
            } catch (err) {
                console.error("Error al cargar detalle del vehículo:", err);
                setError("Error de conexión. Verifica tu AppSync API Key."); 
            } finally {
                setLoading(false);
            }
        };

        fetchVehicle();
    }, [id]);

    // MANEJADOR ACTUALIZADO: Envío directo a WhatsApp con los datos solicitados
    const handleLeadSubmission = (e) => {
        e.preventDefault();
        
        const mensajeData = `*Nueva Solicitud de Cita - Vimcar Broker*
---------------------------
🚗 *Vehículo:* ${vehicle.year} ${vehicle.make} ${vehicle.model}
👤 *Cliente:* ${leadForm.customerName}
📅 *Fecha:* ${leadForm.appointmentDate}
⏰ *Hora:* ${leadForm.appointmentTime}
🔗 *Link:* ${window.location.href}
---------------------------`;

        const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(mensajeData)}`;

        // Abrir WhatsApp
        window.open(whatsappUrl, '_blank');

        // Resetear y cerrar
        setIsModalOpen(false);
        setLeadForm({ customerName: '', customerPhone: '', appointmentDate: '', appointmentTime: '' });
    };
    
    if (loading) return <div style={{textAlign: 'center', padding: '50px'}}>Cargando vehículo...</div>;
    if (error) return <div style={{textAlign: 'center', padding: '50px', color: 'red', fontWeight: 'bold'}}>{error}</div>;
    if (!vehicle) return null; 

    const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(`Me interesa el vehículo ${vehicle.year} ${vehicle.make} ${vehicle.model} (ID: ${vehicle.id}) que vi en su página web.`)}`;

    const styles = {
        pageContainer: { padding: '20px', maxWidth: '1200px', margin: '0 auto', width: '100%', boxSizing: 'border-box', overflowX: 'hidden' },
        infoBlock: { backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '8px', width: '100%', boxSizing: 'border-box' },
        mainBlock: { width: '100%', boxSizing: 'border-box' },
        priceBox: { backgroundColor: '#007bff', color: 'white', padding: '15px', textAlign: 'center', borderRadius: '8px', marginBottom: '15px', width: '100%' },
        mainImageContainer: { width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', marginBottom: '20px', borderRadius: '8px', backgroundColor: '#fff' },
        mainImageStyle: { width: '100%', height: '100%', objectFit: 'contain', borderRadius: '8px' },
        button: { width: '100%', padding: '12px', borderRadius: '4px', border: 'none', fontSize: '1em', cursor: 'pointer', margin: '5px 0', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none', boxSizing: 'border-box' },
        citaButton: { backgroundColor: '#28a745', color: 'white' },
        whatsappButton: { backgroundColor: '#25D366', color: 'white' },
        detailsGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginTop: '15px', fontSize: '0.9em' },
        detailItem: { padding: '10px', backgroundColor: 'white', borderRadius: '4px', border: '1px solid #ddd', textAlign: 'center', minHeight: '50px', display: 'flex', flexDirection: 'column', justifyContent: 'center', fontSize: '1em' },
        modal: { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
        modalContent: { backgroundColor: '#fff', padding: '30px', borderRadius: '10px', width: '90%', maxWidth: '400px', position: 'relative' },
        close: { position: 'absolute', top: '10px', right: '15px', fontSize: '24px', cursor: 'pointer', color: '#aaa' },
        formInput: { width: '100%', padding: '10px', margin: '8px 0', boxSizing: 'border-box', borderRadius: '4px', border: '1px solid #ccc' },
        formButton: { backgroundColor: '#007bff', color: 'white', padding: '12px 20px', border: 'none', borderRadius: '4px', cursor: 'pointer', width: '100%', marginTop: '10px', fontSize: '1em' }
    };
    
    const thumbnailKeys = vehicle.allImageKeys || (vehicle.imageKey ? [vehicle.imageKey] : []);
    
    return (
        <div className="detalle-pagina-contenedor" style={styles.pageContainer}>
             <div style={{marginBottom: '20px', padding: '0 10px'}}>
                <a href="/catalogo" style={{fontSize: '1em', textDecoration: 'none', color: '#007bff'}}>
                    ← Volver al Catálogo
                </a>
            </div>
            
            <h1 style={{textAlign: 'center', margin: '20px 0', color: '#333', fontSize: '2em', padding: '0 10px'}}>
                {vehicle.year} {vehicle.make} {vehicle.model}
            </h1>

            <div className="content-grid">
                <div className="main-block" style={styles.mainBlock}>
                    {mainImage && (
                        <div className="main-image-container" style={styles.mainImageContainer}> 
                            <img src={mainImage} alt={`${vehicle.make} ${vehicle.model} principal`} style={styles.mainImageStyle} />
                        </div>
                    )}

                    {thumbnailKeys.length > 1 && (
                        <div className="miniaturas" style={{display: 'flex', overflowX: 'auto', gap: '10px', padding: '10px 0', maxWidth: '100%', boxSizing: 'border-box'}}>
                            {thumbnailKeys.map((key, index) => (
                                <img
                                    key={index}
                                    src={getS3ImageUrl(key)}
                                    alt={`Miniatura ${index + 1}`}
                                    style={{
                                        width: '70px', height: '50px', minWidth: '70px', objectFit: 'cover',
                                        cursor: 'pointer', borderRadius: '4px',
                                        border: mainImage === getS3ImageUrl(key) ? '2px solid #007bff' : '2px solid transparent'
                                    }}
                                    onClick={() => setMainImage(getS3ImageUrl(key))}
                                />
                            ))}
                        </div>
                    )}
                    
                    <h2 style={{marginTop: '20px', borderTop: '1px solid #ddd', paddingTop: '15px', fontSize: '1.7em'}}>Descripción del Vehículo</h2>
                    <p style={{fontSize: '1em'}}>{vehicle.description || 'No hay descripción disponible para este vehículo.'}</p>

                    {vehicle.videoURL && (
                        <div style={{marginTop: '20px'}}>
                            <h2 style={{fontSize: '1.7em'}}>Video del Vehículo</h2>
                            <iframe 
                                title="Video del Vehículo"
                                style={{width: '100%', height: "315px", border: '0'}}
                                src={vehicle.videoURL.replace("watch?v=", "embed/")} 
                                frameBorder="0" 
                                allowFullScreen
                            />
                        </div>
                    )}
                </div>

                <div className="info-block" style={styles.infoBlock}> 
                    <div style={{width: '100%', boxSizing: 'border-box'}}> 
                        <div style={styles.priceBox}>
                            <small>PRECIO</small>
                            <p style={{fontSize: '2.5em', margin: '0', fontWeight: 'bold'}}>${vehicle.price?.toLocaleString()}</p>
                        </div>

                        <p style={{textAlign: 'center', marginBottom: '15px', fontSize: '1em', width: '100%'}}>¡Contáctanos hoy para asegurar esta oferta!</p>
                        
                        <button onClick={() => setIsModalOpen(true)} style={{...styles.button, ...styles.citaButton}}>
                            <FaCalendarAlt style={{marginRight: '10px'}}/> Solicitar Cita para Ver el Vehículo
                        </button>
                        
                        <a href={whatsappLink} target="_blank" rel="noopener noreferrer" style={{...styles.button, ...styles.whatsappButton}}>
                            <FaWhatsapp style={{marginRight: '10px'}}/> Preguntar por WhatsApp
                        </a>
                    </div>
                    
                    <hr style={{border: '0', borderTop: '1px solid #ddd', margin: '20px 0'}} />

                    <h3 style={{borderBottom: '1px solid #ddd', paddingBottom: '5px', marginTop: '10px', fontSize: '1.5em'}}>Detalles Rápidos</h3>
                    <div style={styles.detailsGrid}>
                        <div className="detail-item" style={styles.detailItem}>
                            <strong>Millas:</strong> <br/> {vehicle.mileage?.toLocaleString()}
                        </div>
                        <div className="detail-item" style={styles.detailItem}>
                            <strong>Título:</strong> <br/> {vehicle.titleStatus}
                        </div>
                        <div className="detail-item" style={styles.detailItem}>
                            <strong>Estado Venta:</strong> <br/> {vehicle.status}
                        </div>
                        <div className="detail-item" style={styles.detailItem}>
                            <strong>Características:</strong> <br/> {vehicle.isFeatured ? 'Financiamiento' : 'Cash'}
                        </div>
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <div style={styles.modal}>
                    <div style={styles.modalContent}>
                        <span style={styles.close} onClick={() => setIsModalOpen(false)}>&times;</span>
                        <h2 style={{marginBottom: '10px'}}>Agenda tu Cita</h2>
                        <form onSubmit={handleLeadSubmission}>
                            <label style={{fontSize: '0.9em', fontWeight: 'bold'}}>Nombre:</label>
                            <input 
                                type="text" placeholder="Tu Nombre" required style={styles.formInput}
                                value={leadForm.customerName}
                                onChange={(e) => setLeadForm({...leadForm, customerName: e.target.value})}
                            />
                            <label style={{fontSize: '0.9em', fontWeight: 'bold'}}>Día de la Cita:</label>
                            <input 
                                type="date" required style={styles.formInput}
                                value={leadForm.appointmentDate}
                                onChange={(e) => setLeadForm({...leadForm, appointmentDate: e.target.value})}
                            />
                            <label style={{fontSize: '0.9em', fontWeight: 'bold'}}>Hora de la Cita:</label>
                            <input 
                                type="time" required style={styles.formInput}
                                value={leadForm.appointmentTime}
                                onChange={(e) => setLeadForm({...leadForm, appointmentTime: e.target.value})}
                            />
                            <button type="submit" style={styles.formButton}>
                                <FaWhatsapp style={{marginRight: '8px'}}/> Enviar a WhatsApp
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DetailPage;